import { useNavigate } from 'react-router-dom'
import EntitiesSort from './EntitiesSort'
import { Sort } from 'util/constants'

interface Props {
    sort: Sort
    searchParams: URLSearchParams
}

const SolutionsListSelector = ({ sort, searchParams }: Props) => {
    const navigate = useNavigate()

    const handleSortChange = (newSort: Sort) => {
        const newSearchParams = new URLSearchParams(searchParams)
        navigate(`/solutions/${newSort}?${newSearchParams.toString()}`)
    }

    return (
        <div className="solutions-list-selector flex items-center gap-2">
            <EntitiesSort entityType="solutions" sort={sort} onSortChange={handleSortChange} />
        </div>
    )
}

export default SolutionsListSelector